import * as React from 'react'
import { style } from 'typestyle'
import styled from './styled'

export const FlexDiv = styled.div({
  display: 'flex',
})

/**
 * A container with children that has a "position: relative"
 */
export const RelativeDiv = (props: { children?: React.ReactNode }) => (
  <div className={style({ position: 'relative' })}>{props.children}</div>
)
